import { Platform } from 'react-native';
import SimpleStorage from './simpleStorage';

const GUEST_ZIP_KEY = 'bookapt_guest_zip';
const GUEST_COUNTRY_KEY = 'bookapt_guest_country';

async function ensureStorage(): Promise<void> {
  await SimpleStorage.forceInitialize();
}

export async function getGuestZipcodeAsync(): Promise<string | null> {
  await ensureStorage();
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      const zip = sessionStorage.getItem(GUEST_ZIP_KEY);
      if (zip && zip.trim()) {
        return zip.trim();
      }
    } catch {
      /* ignore */
    }
  }
  const stored = await SimpleStorage.getItem(GUEST_ZIP_KEY);
  return stored && stored.trim() ? stored.trim() : null;
}

export function getGuestZipcode(): string | null {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      const zip = sessionStorage.getItem(GUEST_ZIP_KEY);
      return zip && zip.trim() ? zip.trim() : null;
    } catch {
      return null;
    }
  }
  return null;
}

export function getGuestCountry(): string {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      return sessionStorage.getItem(GUEST_COUNTRY_KEY) || 'USA';
    } catch {
      return 'USA';
    }
  }
  return 'USA';
}

export async function setGuestZipcodeAsync(zipcode: string, country?: string): Promise<void> {
  await ensureStorage();
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      sessionStorage.setItem(GUEST_ZIP_KEY, zipcode);
      if (country) {
        sessionStorage.setItem(GUEST_COUNTRY_KEY, country);
      }
    } catch {
      /* ignore */
    }
  }
  await SimpleStorage.setItem(GUEST_ZIP_KEY, zipcode);
  if (country) {
    await SimpleStorage.setItem(GUEST_COUNTRY_KEY, country);
  }
}

export function setGuestZipcode(zipcode: string, country?: string): void {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      sessionStorage.setItem(GUEST_ZIP_KEY, zipcode);
      if (country) {
        sessionStorage.setItem(GUEST_COUNTRY_KEY, country);
      }
    } catch {
      /* ignore */
    }
  }
  void setGuestZipcodeAsync(zipcode, country);
}

export function clearGuestZipcode(): void {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      sessionStorage.removeItem(GUEST_ZIP_KEY);
      sessionStorage.removeItem(GUEST_COUNTRY_KEY);
    } catch {
      /* ignore */
    }
  }
  void SimpleStorage.removeItem(GUEST_ZIP_KEY);
  void SimpleStorage.removeItem(GUEST_COUNTRY_KEY);
}
